// Copyright (c) 2022, Comsearch, Inc., All rights reserved

export const SYSTEM_MAINTENANCE_END_HOUR = 5
export const SYSTEM_MAINTENANCE_START_HOUR = 1
export const SYSTEM_MAINTENANCE_WARNING_NOTIFICATION = 'SYSTEM_MAINTENANCE_WARNING_NOTIFICATION'
